import React, { useState } from "react";
import { Tag } from "react-feather";
import GenericTagComp from "../../../../genericComponents/tag/GenericTagComp";

/**
 * ExpandableList renders <li> items with expand/collapse behavior.
 * @param {Object} props
 * @param {Array<any>} props.items - Array of raw items
 * @param {Function} props.renderItem - Function to render each item (like renderValue)
 * @param {number} props.visibleCount - Number of items to show initially
 * @param {boolean} props.isCustom - Whether to render in custom format
 */
const ExpandableList = ({
  items = [],
  renderItem,
  visibleCount = 1,
  isCustom,
}) => {
  const [expanded, setExpanded] = useState(false);

  if (!items?.length) return null;

  const visibleItems = items.slice(0, visibleCount);
  const hiddenItems = items.slice(visibleCount);

const renderCustomItem = (item) => {
  const domain = item.source ? new URL(item.source).hostname.replace(/^www\./, '') : 'link';

  return (
    <div>
      <div>{item.signal}</div>
      <div style={{ flexDirection: "row", display: "flex", gap: "0.5rem", alignItems:"center" }}>
        <div>Source:</div>
       
        <a
          href={item.source}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "black",
            fontSize: "0.8rem",
          }}
        >
   
       
       {  `${domain}${item?.date ? ' - ' + item.date : ''}`}
       
 

        </a>
      </div>
    </div>
  );
};


  return (
    <>
      {visibleItems.map((item, idx) => (
        <>
        <li
          key={idx}
          style={{ display: "flex", flexDirection: "row", alignItems: "start" }}
        >
          {isCustom ? renderCustomItem(item) : renderItem(item)}
          {idx === 0 && !expanded && hiddenItems.length > 0 && (
            <span
              className="expandable-para-view-toggle-btn"
              style={{
                cursor: "pointer",
                marginLeft: "0.5rem",
                color: "#007bff",
              }}
              onClick={() => setExpanded(true)}
            >
              View More
            </span>
            
          )}
        
        </li>
        {expanded && isCustom && <hr/>}
        </>
      ))}

      {expanded && (
        <>
          {hiddenItems.map((item, idx) => (
           <> <li key={idx + visibleCount}>
              {isCustom ? renderCustomItem(item) : renderItem(item)}
            {isCustom && <hr/>}
            </li>
                
                 </>
          ))}
          <li
            className="expandable-para-view-toggle-btn"
            style={{ cursor: "pointer", color: "#007bff" }}
            onClick={() => setExpanded(false)}
          >
            View Less
          </li>
        </>
      )}
    </>
  );
};

export default ExpandableList;
